import React, { useEffect, useState } from 'react';
import Layout from '../../../components/common/pageLayout';
import FormBuilder from '../../../components/Production/Configure/NewBuildingPreLaunchingCheckList';
import { v3_createNewBuildingPreLaunchingCheckListFields, v3_fetchNewBuildingPreLaunchingCheckListFields } from '../../../actions/v3/productionForm';
import { toast } from 'react-toastify';
import constant from '../../../constant';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ConfigMeta, findDuplicateSection, findEmptySection, isStaleConfigError, toastSaveResult } from '../../../components/Production/Configure/configMeta';

const NewBuildingPreLaunchingCheckList = (props) => {

  const [state, setState] = useState([
    {
      id: '',
      name: '',
      active: true,
      items: [
        { id: '', label: '', active: true },
      ],
    },
  ]);

  const [showLoader, setShowLoader] = useState(false);
  // Config is global and shared; keep the version we loaded so the API can reject
  // a save made on top of someone else's newer one, and collect hard-delete ids.
  const [configMeta, setConfigMeta] = useState(null);
  const [configVersion, setConfigVersion] = useState('');
  const [deletedIds, setDeletedIds] = useState([]);

  useEffect(() => {
    setShowLoader(true);
    v3_fetchNewBuildingPreLaunchingCheckListFields()
      .then((res) => {
        if (res.status) {
          setConfigMeta(res.result.configMeta || null);
          setConfigVersion(res.result.configMeta?.version || '');
          setState(res.result.sections && res.result.sections.length > 0 ? res.result.sections : [
            {
              id: '',
              name: '',
              active: true,
              items: [{ id: '', label: '', active: true }]
            }
          ]);
        } else {
          toast.error(res.error);
        }
      })
      .catch((error) => {
        console.error('Fetch error:', error);
        toast.error('Something went wrong while fetching.');
      })
      .finally(() => {
        setShowLoader(false);
      });
  }, []);

  const onSubmit = () => {
    const emptySection = findEmptySection(state);
    if (emptySection) {
      toast.error(`Section "${emptySection.name || '(unnamed)'}" needs at least one item with a label before it can be saved.`);
      return;
    }
    const duplicateSection = findDuplicateSection(state);
    if (duplicateSection) {
      toast.error(`Section "${duplicateSection.name || '(unnamed)'}" duplicates another section. Section names must be unique.`);
      return;
    }
    setShowLoader(true)
    const payload = {
      configVersion,
      deletedIds,
      data: state.map(section => ({
        id: section.id,
        name: section.name,
        active: section.active,
        items: section.items.map(item => ({
          id: item.id,
          label: item.label,
          active: item.active,
        })),
      })),
    };

    v3_createNewBuildingPreLaunchingCheckListFields(payload)
      .then((res) => {
        if (res.status) {
          toastSaveResult(res.result);
          props.history.push(constant.Authedcomponent.production.url)
        } else {
          // On STALE_CONFIG the edits stay on screen so they can be reapplied after a reload.
          toast.error(res.error);
        }
      })
      .catch((error) => {
        console.error('Submission error:', error);
        toast.error('Something went wrong while submitting.');
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  return (
    <Layout title={'New Building Pre-Launching Check List'}>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="checklist-title-bx">
                <div className="row">
                  <div className="col-md-8">
                    <div className="text-left">
                      <h4>New Building Pre Launching Check List</h4>
                      <p>Following to be checked as a preparation for launching</p>
                    </div>
                  </div>
                  <div className="col-md-4 text-md-end">
                    {/* This config is global - one shared item list per form, not per project/hull. */}
                    <ConfigMeta meta={configMeta} />
                  </div>
                </div>
              </div>

              <div className="row" id={1}>
                <div className="col-md-12">
                  <FormBuilder
                    state={state}
                    setState={setState}
                    onDeleteSavedItem={(id) => setDeletedIds((prev) => [...prev, id])}
                  />

                  {/* Submit Section */}
                  <SubmitSection
                    onSubmit={onSubmit}
                  />

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

const SubmitSection = ({ onSubmit }) => {
  const history = useHistory()
  return (
    <>


      <div className="row mt-4">
        <div className="col-lg-12 text-left">
          <button
            type="button"
            className="btn btn-success"
            style={{
              backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
              borderColor: "#2b5a7e",
            }}
            onClick={onSubmit}
          >
            Save
          </button>

          <button
            type="reset"
            onClick={() => { history.push(constant.Authedcomponent.submittedNewBuildingPreLaunchingCheckList.url) }}
            className="btn btn-danger ms-3"
            style={{
              backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
              borderColor: "#2b5a7e",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};
export default NewBuildingPreLaunchingCheckList
